import { useState, useEffect } from "react";
import { exibeProgressaoNaTela } from "../utils/escalas";
import ProgressionSelect from "./ProgressionSelect";
import VoicingSelect from "./VoicingSelect";

export default function SelectOption({ chordsApp, setChordsApp }) {
  const graus = [
    [2, 5, 1, 6],
    [1, 6, 2, 5],
    [1, 4, 2, 5],
  ];

  const aberturas = [
    "1,5 | 7,3,5",
    "1,5 | 3,5,7",
    "1,7 | 1,3,5",
    "3,7 | 1,5,1",
    "3,1 | 5,7,3",
    "3,7,1 | 5,1,5",
  ];

  const [grau, setGrau] = useState([2, 5, 1, 6]);
  const [chord1, setChord1] = useState({ acorde: "acorde1", grau: grau[0], abertura: aberturas[0] });
  const [chord2, setChord2] = useState({ acorde: "acorde2", grau: grau[1], abertura: aberturas[0] });
  const [chord3, setChord3] = useState({ acorde: "acorde3", grau: grau[2], abertura: aberturas[0] });
  const [chord4, setChord4] = useState({ acorde: "acorde4", grau: grau[3], abertura: aberturas[0] });

  const UpdateVoicingChord = (acorde, abertura) => {
    if (acorde === "acorde1") {
      setChord1((prevChord) => ({ ...prevChord, grau: grau[0], abertura }));
    }
    if (acorde === "acorde2") {
      setChord2({ acorde, grau: grau[1], abertura });
    }
    if (acorde === "acorde3") {
      setChord3({ acorde, grau: grau[2], abertura });
    }
    if (acorde === "acorde4") {
      setChord4({ acorde, grau: grau[3], abertura });
    }
    if (acorde === 0) {
      setChord1((prev) => ({ ...prev, grau: grau[0] }));
      setChord2((prev) => ({ ...prev, grau: grau[1] }));
      setChord3((prev) => ({ ...prev, grau: grau[2] }));
      setChord4((prev) => ({ ...prev, grau: grau[3] }));
    }
  };

  const changeIntervalsProgression = (valor) => {
    const notes = valor.split(",").map(Number);
    setGrau(notes);
    setChord1((prevChord) => ({ ...prevChord, grau: notes[0] }));
    setChord2((prevChord) => ({ ...prevChord, grau: notes[1] }));
    setChord3((prevChord) => ({ ...prevChord, grau: notes[2] }));
    setChord4((prevChord) => ({ ...prevChord, grau: notes[3] }));
  };

  useEffect(() => {
    //observa chord1…chord4 e recalcula todas as progressões sempre que usuário mudar
    setChordsApp(exibeProgressaoNaTela([chord1, chord2, chord3, chord4]));
  }, [chord1, chord2, chord3, chord4, setChordsApp]);

  return (
    <>
      <div className="p-4 bg-white rounded shadow-sm w-full md:w-1/3">
        <ProgressionSelect graus={graus} onChange={changeIntervalsProgression} />

        <VoicingSelect
          label={
            <>
              defina abertura do <span>1º acorde</span> da progressão
            </>
          }
          acordeName="acorde1"
          aberturas={aberturas}
          onSelect={UpdateVoicingChord}
        />

        <VoicingSelect
          label={
            <>
              defina abertura do <span>2º acorde</span> da progressão
            </>
          }
          acordeName="acorde2"
          aberturas={aberturas}
          onSelect={UpdateVoicingChord}
        />

        <VoicingSelect
          label={
            <>
              defina abertura do <span>3º acorde</span> da progressão
            </>
          }
          acordeName="acorde3"
          aberturas={aberturas}
          onSelect={UpdateVoicingChord}
        />

        <VoicingSelect
          label={
            <>
              defina abertura do <span>4º acorde</span> da progressão
            </>
          }
          acordeName="acorde4"
          aberturas={aberturas}
          onSelect={UpdateVoicingChord}
        />
      </div>
    </>
  );
}
